import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';

export interface FolderLanguageBadgeProps {
  /** Language label, e.g. "French". */
  label: string;
  /** ISO 3166 alpha-2 code of the flag, e.g. "fr". */
  flag?: string | null;
}

/** KD-3842: the trip language of a client folder, flag and name. */
export default function FolderLanguageBadge({
  label,
  flag,
}: FolderLanguageBadgeProps) {
  const { t } = useTranslation('folders');

  return (
    <KoobTooltip tip={t('modal.tripLanguage')}>
      <span
        className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600"
        data-testid="folder-trip-language"
      >
        {flag && (
          <span className={`flag-icon flag-icon-${flag.toLowerCase()}`} />
        )}
        {label}
      </span>
    </KoobTooltip>
  );
}
